export default build =>
    build.mutation({
        query(payload) {
            console.log("payload",payload)
            return {
                url: '/exam/createAgent',
                method: 'POST',
                body: payload,
               
            };
        },
        invalidatesTags: ['allAgents'],
    })
